import React from 'react';
import { footerData } from '../data/mock';
import { Linkedin, Facebook } from 'lucide-react';

const socialIconMap = {
  linkedin: Linkedin,
  facebook: Facebook,
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#F8EEF2] border-t border-[#C5366A]/10">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" dir="rtl">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_3a5ab85f-da0a-4b5c-ba39-99c6e6da22ed/artifacts/l8m2yxt7_logo%20big%20razblizovsky.png"
              alt="Logo"
              className="h-10 mb-6"
            />
            <p className="text-[#6B6B6B] text-base leading-relaxed max-w-md">
              {footerData.logo}
            </p>

            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              {footerData.socialLinks.map((social) => {
                const IconComponent = socialIconMap[social.platform];
                return (
                  <a
                    key={social.platform}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-white hover:bg-[#C5366A] text-[#6B6B6B] hover:text-white rounded-lg transition-all duration-300 shadow-sm"
                    aria-label={social.platform}
                  >
                    <IconComponent className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#2D2D2D] text-lg font-semibold mb-6">ניווט מהיר</h4>
            <ul className="space-y-3">
              {footerData.quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#6B6B6B] hover:text-[#C5366A] transition-colors duration-300 text-base"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-[#2D2D2D] text-lg font-semibold mb-6">מידע משפטי</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/terms"
                  className="text-[#6B6B6B] hover:text-[#C5366A] transition-colors duration-300 text-base"
                >
                  תקנון ותנאי שימוש
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="text-[#6B6B6B] hover:text-[#C5366A] transition-colors duration-300 text-base"
                >
                  מדיניות פרטיות
                </a>
              </li>
              <li>
                <a
                  href="/accessibility"
                  className="text-[#6B6B6B] hover:text-[#C5366A] transition-colors duration-300 text-base"
                >
                  הצהרת נגישות
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-[#C5366A]/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" dir="rtl">
            <p className="text-[#6B6B6B] text-sm">
              כל הזכויות שמורות למרכז הישראלי לעצמאות דיגיטלית © {currentYear}
            </p>
            <div className="flex items-center gap-4 text-sm">
              <a href="/terms" className="text-[#6B6B6B] hover:text-[#C5366A] transition-colors">
                תקנון ותנאי שימוש
              </a>
              <span className="text-[#C5366A]/30">|</span>
              <a href="/privacy" className="text-[#6B6B6B] hover:text-[#C5366A] transition-colors">
                מדיניות פרטיות
              </a>
              <span className="text-[#C5366A]/30">|</span>
              <a href="/accessibility" className="text-[#6B6B6B] hover:text-[#C5366A] transition-colors">
                הצהרת נגישות
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
